// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 343 ? "e3869ee7" : chunkId) + "." + {"63":"8cf2d302db719339","343":"4be5ae03fcae0360","444":"ebf38f73b3132ab0"}[chunkId] + ".js";
};